import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/sumit-jain-bg-square.jpg" className="logo-img" alt="logo" />
        <div className="name-svg">
          <svg width="749" height="104" viewBox="0 0 749 104" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34.912 103.008C28.288 103.008 22.336 101.856 17.056 99.552C11.872 97.152 7.792 93.888 4.816 89.76C1.84 85.536 0.304 80.688 0.208001 75.216H14.176C14.656 79.92 16.576 83.904 19.936 87.168C23.392 90.336 28.384 91.92 34.912 91.92C41.152 91.92 46.048 90.384 49.6 87.312C53.248 84.144 55.072 80.112 55.072 75.216C55.072 71.376 54.016 68.256 51.904 65.856C49.792 63.456 47.152 61.632 43.984 60.384C40.816 59.136 36.544 57.792 31.168 56.352C24.544 54.624 19.216 52.896 15.184 51.168C11.248 49.44 7.84 46.752 4.96 43.104C2.176 39.36 0.784001 34.368 0.784001 28.128C0.784001 22.656 2.176 17.808 4.96 13.584C7.744 9.35999 11.632 6.09599 16.624 3.79199C21.712 1.488 27.52 0.335996 34.048 0.335996C43.456 0.335996 51.136 2.688 57.088 7.392C63.136 12.096 66.544 18.336 67.312 26.112H52.912C52.432 22.272 50.416 18.912 46.864 16.032C43.312 13.056 38.608 11.568 32.752 11.568C27.28 11.568 22.816 13.008 19.36 15.888C15.904 18.672 14.176 22.608 14.176 27.696C14.176 31.344 15.184 34.32 17.2 36.624C19.312 38.928 21.856 40.704 24.832 41.952C27.904 43.104 32.176 44.448 37.648 45.984C44.272 47.808 49.6 49.632 53.632 51.456C57.664 53.184 61.12 55.92 64 59.664C66.88 63.312 68.32 68.304 68.32 74.64C68.32 79.536 67.024 84.144 64.432 88.464C61.84 92.784 58 96.288 52.912 98.976C47.824 101.664 41.824 103.008 34.912 103.008ZM100.42 1.632V65.136C100.42 74.064 102.58 80.688 106.9 85.008C111.316 89.328 117.412 91.488 125.188 91.488C132.868 91.488 138.868 89.328 143.188 85.008C147.604 80.688 149.812 74.064 149.812 65.136V1.632H162.916V64.992C162.916 73.344 161.236 80.4 157.876 86.16C154.516 91.824 149.956 96.048 144.196 98.832C138.532 101.616 132.148 103.008 125.044 103.008C117.94 103.008 111.508 101.616 105.748 98.832C100.084 96.048 95.5716 91.824 92.2116 86.16C88.9476 80.4 87.3156 73.344 87.3156 64.992V1.632H100.42ZM286.584 2.352V102H273.48V27.696L240.36 102H231.144L197.88 27.552V102H184.776V2.352H198.888L235.752 84.72L272.616 2.352H286.584ZM321.911 1.632V102H308.807V1.632H321.911ZM406.02 1.632V12.288H378.66V102H365.556V12.288H338.052V1.632H406.02ZM511.085 1.632V75.792C511.085 84.048 508.541 90.672 503.453 95.664C498.365 100.56 491.645 103.008 483.293 103.008C474.845 103.008 468.077 100.512 462.989 95.52C457.901 90.432 455.357 83.52 455.357 74.784H468.461C468.557 79.68 469.805 83.664 472.205 86.736C474.701 89.808 478.397 91.344 483.293 91.344C488.189 91.344 491.837 89.904 494.237 87.024C496.637 84.048 497.837 80.304 497.837 75.792V1.632H511.085ZM596.229 79.68H552.453L544.389 102H530.564L566.853 2.208H581.973L618.117 102H604.293L596.229 79.68ZM592.485 69.024L574.341 18.336L556.197 69.024H592.485ZM647.036 1.632V102H633.932V1.632H647.036ZM748.281 102H735.177L682.473 22.08V102H669.369V1.488H682.473L735.177 81.264V1.488H748.281V102Z" fill="black" />
          </svg>
        </div>
        <div className="contact-links">
          <a
            href="mailto:sumeetsuniljain@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="bi bi-envelope-fill"></i>
          </a>
          <a
            href="https://github.com/sumitjain-"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="bi bi-github"></i>
          </a>
          <a
            href="tel:+91-9028008444"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="bi bi-phone-fill"></i>
          </a>
          <a
            href="https://blog.sumitjain.work/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="bi bi-pen-fill"></i>
          </a>
        </div>
        <div className="contact-links resume mt-1">
          <a
            href="https://docs.google.com/document/d/1X3_SpYRDO03zZW_9gnZaTIJ9EbksKYi-v-TZwmzfJQ0/edit?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="d-inline-block"
          >
            résumé
          </a>
        </div>
        <div className="contact-links resume mt-1">
          <a
            href="https://sumitjain.work/sumit-jain-resume-jun-2024.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="bi bi-printer-fill"></i>
          </a>
        </div>
      </header>
    </div>
  );
}

export default App;
